import React from 'react';
import { Facebook, Twitter, Instagram, Send, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#020202] pt-20 pb-10 border-t border-[#c9a96e]/10" data-id="element-38">
      <div className="max-w-7xl mx-auto px-6" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-40">
          {/* Brand */}
          <div data-id="element-41">
            <div className="flex items-center gap-2 mb-6" data-id="element-42">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#c9a96e] to-[#8a7035] flex items-center justify-center text-black font-serif font-bold text-lg" data-id="element-43">
                S
              </div>
              <span className="text-2xl font-serif font-bold text-white tracking-wide" data-id="element-44">
                后宫 <span className="text-[#c9a96e]" data-id="element-45">SGHarem</span>
              </span>
            </div>
            <p className="text-neutral-500 text-sm leading-relaxed mb-6" data-id="element-46">
              Singapore's premier directory for high-class companions, escorts,
              and massage services. Defining luxury and discretion.
            </p>
            <div className="flex gap-4" data-id="element-47">
              <a href="#" className="w-10 h-10 rounded-full bg-[#111111] border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all" data-id="element-48">
                <Twitter size={18} data-id="element-49" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111111] border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all" data-id="element-50">
                <Instagram size={18} data-id="element-51" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111111] border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all" data-id="element-52">
                <Send size={18} data-id="element-53" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-54">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-55">Quick Links</h4>
            <ul className="space-y-3" data-id="element-56">
              {['Home', 'Featured Companions', 'Services', 'Membership', 'Contact Us'].map(item => <li key={item} data-id="element-57">
                  <a href="#" className="text-neutral-500 hover:text-[#c9a96e] transition-colors text-sm" data-id="element-58">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Areas Served */}
          <div data-id="element-59">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-60">Areas Served</h4>
            <ul className="space-y-3" data-id="element-61">
              {['Orchard Road', 'Marina Bay Sands', 'Sentosa Cove', 'Clarke Quay', 'Bugis', 'Tanjong Pagar'].map(item => <li key={item} data-id="element-62">
                  <a href="#" className="text-neutral-500 hover:text-[#c9a96e] transition-colors text-sm" data-id="element-63">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-64">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-65">Contact Us</h4>
            <div className="space-y-4" data-id="element-66">
              <div className="flex items-center gap-3 text-neutral-400" data-id="element-67">
                <MessageCircle size={18} className="text-[#c9a96e]" data-id="element-68" />
                <span className="text-sm" data-id="element-69">WeChat: SGHarem_Official</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-400" data-id="element-70">
                <Send size={18} className="text-[#c9a96e]" data-id="element-71" />
                <span className="text-sm" data-id="element-72">Telegram: @SGHarem_SG</span>
              </div>
              <div className="p-4 bg-[#111111] border border-neutral-800 rounded-lg mt-4" data-id="element-73">
                <p className="text-xs text-neutral-500 text-center" data-id="element-74">
                  For advertising inquiries, please contact our support team via
                  Telegram.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-75">
          <p className="text-neutral-600 text-xs" data-id="element-76">
            © 2024 SGHarem. All rights reserved.
          </p>
          <div className="flex items-center gap-2 px-3 py-1 bg-[#1a1a1a] rounded border border-neutral-800" data-id="element-77">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-78" />
            <span className="text-neutral-400 text-xs font-medium" data-id="element-79">
              Adults Only 18+
            </span>
          </div>
        </div>
      </div>
    </footer>;
}